<template>
    <div class="flex flex-col gap-6">
        <h2 class="text-2xl md:text-4xl font-semibold mb-6">
            Notable Diagnostic Tests Results: Biochemical Tests
        </h2>

        <div>
            <h3 class="text-base md:text-2xl font-semibold mb-3">Biochemical test results:</h3>
            <ul class="list-disc pl-4  font-light">
                <li>
                    Urinalysis showed 0.3 g/L albuminuria, 25 erythrocytes/μL, and pyuria with 5-10 cells/high power
                    field
                </li>
                <li>
                    Laboratory test results completed on initiation found that <span class="font-semibold">creatinine and urea levels were high compared with reference ranges</span> (see full laboratory results): 1644 μmol/L and 42.2 mmol/L, respectively
                </li>
                <li>
                    High-sensitivity troponin-T was elevated at 233 ng/L (normal ≤14 ng/L) in keeping with <span class="font-semibold">kidney failure</span>, with stable serial sampling at Hour 3 and Hour 30
                </li>
                <li><span class="font-semibold">Unfortunately, plasma oxalate levels were not available</span></li>
            </ul>
        </div>

        <div>
            <h3 class="text-base md:text-2xl font-semibold">
                Laboratory Results On Initial Presentation - 24-Hour Urine Collection
            </h3>
            <p class="pb-3  font-light">24-hour urine collection and analysis was completed 4 days after presentation and prior to dialysis
                initiation</p>

            <table class="w-full table-fixed border-collapse border-solid border-2 border-darkergrey break-words">
                <thead class="text-center text-white text-base md:text-lg">
                    <tr class="bg-lightblue">
                        <th class="p-3 border-solid border-2 border-darkergrey">24-hour urine collection</th>
                        <th class="p-3 border-solid border-2 border-darkergrey">Result</th>
                        <th class="p-3 border-solid border-2 border-darkergrey">Reference Range</th>
                    </tr>
                </thead>

                <tbody class="text-center  font-light text-sm md:text-base">
                    <tr class="bg-grey">
                        <td class="p-3 border-solid border-2 border-darkergrey">TV, mL</td>
                        <td class="p-3 border-solid border-2 border-darkergrey">1025</td>
                        <td class="p-3 border-solid border-2 border-darkergrey">&nbsp;</td>
                    </tr>
                    <tr class="bg-white">
                        <td class="p-3 border-solid border-2 border-darkergrey">Urine creatinine, mmol/TV</td>
                        <td class="p-3 border-solid border-2 border-darkergrey">1.2</td>
                        <td class="p-3 border-solid border-2 border-darkergrey">6.3–14.6</td>
                    </tr>
                    <tr class="bg-grey">
                        <td class="p-3 border-solid border-2 border-darkergrey">Oxalate, μmol/TV</td>
                        <td class="p-3 border-solid border-2 border-darkergrey">319</td>
                        <td class="p-3 border-solid border-2 border-darkergrey">40–320</td>
                    </tr>
                    <tr class="bg-white">
                        <td class="p-3 border-solid border-2 border-darkergrey">Citrate, mmol/TV</td>
                        <td class="p-3 border-solid border-2 border-darkergrey">Undetectable</td>
                        <td class="p-3 border-solid border-2 border-darkergrey">≥1.7</td>
                    </tr>
                    <tr class="bg-grey">
                        <td class="p-3 border-solid border-2 border-darkergrey">Protein, g/TV</td>
                        <td class="p-3 border-solid border-2 border-darkergrey">0.2</td>
                        <td class="p-3 border-solid border-2 border-darkergrey">0.05–0.150</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
